import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';
import './modules/register-service-worker';
import navigation from './modules/nagivation';
import GmtEventPusher from './gtm-event-pusher'; //to-do: add npm version
// import CookieConsent from './modules/cookie-consent';

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();
navigation.init();
GmtEventPusher.init();

// window.cookieConsent = CookieConsent;
// if (document.cookie.indexOf('cookie-consent-answered=') === -1) {
//   window.cookieConsent.init();
// }

const formElement = document.querySelector('form');
if(formElement) {

  import('./modules/multiselect').then(multiselect => multiselect.default.init());

  const vehicleSearchElement = document.getElementById('vehicle-search');
  if(vehicleSearchElement) {
    import('./modules/vehicle-search').then((vehicleSearch) => vehicleSearch.default.init());
    import('./modules/analytics').then(analytics => analytics.default.vehicleSearchAnalytics());
  }

  const selectFilters = document.querySelector('.js-filter-models');
  if(selectFilters){
    import('./modules/filter-select').then(fs => fs.default.init());
  }

  //init number range
  import('./modules/number-range').then((range) => {
    range.default.init();
  });

  //init stage forms
  import('./modules/stage-forms').then((stageForms)=> {
    stageForms.default.init();
  });
}

const heroVehicleSearchElement = document.querySelector('.hero-vehicle-search');
if(heroVehicleSearchElement) {
  import('./modules/hero-vehicle-search').then((heroVehicleSearch) => heroVehicleSearch.default.init());
}

const cardCarouselElement = document.querySelector('.card-carousel');
if(cardCarouselElement) {
  import('./modules/card-carousel').then((cardCarousel) => cardCarousel.init());
}

const adCardCarouselElement = document.querySelector('.ad-card-carousel');
if(adCardCarouselElement) {
  import('./modules/ad-card-carousel').then((adCardCarousel) => adCardCarousel.init());
}

const vehicleImageCarousel = document.querySelector('.vehicle-image-carousel');
if(vehicleImageCarousel) {
  import('./modules/vehicle-image-carousel').then((vehicleImageCarousel) => vehicleImageCarousel.init());
}

const vehiclePage = document.querySelector('.vehicle-page');
if(vehiclePage) {
  import('./modules/tabbed-details').then((tabbedDetails) => tabbedDetails.default.init());
}

const fundingCalc = document.querySelector('#funding-calculator');
if(fundingCalc) {
  import('./modules/funding-calculator').then((fundingCalculator) => fundingCalculator.default.init());
}

if(document.getElementsByClassName('hero-vehicle-search')) {
  import('./modules/analytics').then(analytics => analytics.default.heroVehicleSearchAnalytics());
}

if(document.getElementById('vehicle-search-watcher-form')) {
  import('./modules/analytics').then(analytics => analytics.default.searchWatcherAnalytics());
}

const quickSiteSearchContainer = document.getElementById('nav-site-search');

if (quickSiteSearchContainer) {
  import(
    /* webpackChunkName: 'quickSiteSearch' */
    './modules/quick-site-search'
  ).then(({default: QuickSiteSearch}) => (
    new QuickSiteSearch(quickSiteSearchContainer)
  ));
}

if(document.querySelector('iframe[src*="youtube"]')) {
  import('./modules/responsive-iframes').then(iframes => iframes.default.init());
}

if(document.querySelector('.js-datepicker')) {
  import('./modules/datepicker').then(datepicker => datepicker.default.init());
}

if(document.querySelector('.content-page table')) {
  import('./modules/responsive-tables').then(iframes => iframes.default.init());
}

if(document.querySelector('.app-delivery-calculator')) {
  import('./modules/delivery-calculator').then(distanceCalculator => distanceCalculator.default.init());
}

if (document.querySelector('[data-reset-input]')) {
  import('./modules/veho/reset-input').then(ri => ri.default.init());
}
const iframes = document.getElementsByTagName('iframe');
if(iframes.length) {
  import('./modules/youtube').then(youtube => youtube.init());
}
